import type { Airport } from '../data/airports/types';

export function getAirportUrl(airport: Airport): string {
  return `/airport/${airport.iata.toLowerCase()}`;
}